import styled from "@emotion/styled";
import {
  PageContentContainer,
  BodyContainer as BodyContainerBase,
  gridAreas as contentPageGridAreas,
  FooterContainer,
} from "./ContentPageGrid";
import {
  GlobalContainer as GlobalContainerBase,
  gridAreas as globalGridAreas,
} from "@atlas-int/tokens/layout";
import { Outlet } from "react-router";
import NavigationBar from "../components/navigation/ContentPageNav";
import Footer from "../components/footer/Footer";
import { usePageTracking } from "../sharedUtilities/analytics";

const BodyContainer = styled(BodyContainerBase)`
  margin-top: 3rem;
  margin-left: 65px;
`;

const ContentPageGlobalContainer = styled(GlobalContainerBase)`
  height: auto;
  grid-template-areas:
    "${globalGridAreas.content}"
    "${contentPageGridAreas.footer}";
  grid-template-columns: 1fr;
`;

const ContentPage = () => {
  // Track page views on route changes
  usePageTracking();

  return (
    <ContentPageGlobalContainer>
      <PageContentContainer id="static-root">
        <NavigationBar />
        <BodyContainer>
          <Outlet />
        </BodyContainer>
      </PageContentContainer>
      <FooterContainer>
        <Footer />
      </FooterContainer>
    </ContentPageGlobalContainer>
  );
};

export default ContentPage;
